<template>
  <div class="categoriesSlider">
    <div class="categoriesSlider__header"><h2>Sprawdź nasze kategorie</h2></div>
    <div class="categoriesSlider__inner">
      <SwiperSlider ref="slider" class="categoriesSlider__swiper" :options="swiperOptions">
        <nuxt-link
          v-for="(item, index) in items"
          :key="index"
          :to="localePath({ name: 'category-slug', params: { slug: item.slug } })"
          class="categoriesSlider__slide swiper-slide"
          @click="slideClick(index)"
        >
          <span :class="['categoriesSlider__slideIcon', item.iconClass]"></span>
          <p class="categoriesSlider__slideTitle">{{ item.name.replace('i ', 'i&nbsp;') }}</p>
        </nuxt-link>
      </SwiperSlider>
      <div class="categoriesSlider__navigation swiper-navigation">
        <button
          class="categoriesSlider__navigationButton categoriesSlider__navigationButton--prev swiper-button-prev"
          @click="prevEl"
        >
          <span class="categoriesSlider__navigationButtonIcon icon-chevron-left-bold"></span>
        </button>
        <button
          class="categoriesSlider__navigationButton categoriesSlider__navigationButton--next swiper-button-next"
          @click="nextEl"
        >
          <span class="categoriesSlider__navigationButtonIcon icon-chevron-right-bold"></span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import SwiperSlider from '@/components/SwiperSlider';
export default {
  name: 'CategoriesSlider',
  components: { SwiperSlider },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: 2,
        allowTouchMove: false,
        navigation: true,
        breakpoints: {
          480: {
            slidesPerView: 3,
          },
          768: {
            slidesPerView: 5,
          },
          1280: {
            slidesPerView: 6,
          },
        },
      },
    };
  },
  computed: {
    swiper() {
      if (typeof this.$refs.slider.swiper !== 'undefined') {
        return this.$refs.slider.swiper;
      }
      return false;
    },
  },
  methods: {
    prevEl() {
      if (this.swiper) {
        this.swiper.slidePrev();
      }
    },
    nextEl() {
      if (this.swiper) {
        this.swiper.slideNext();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.categoriesSlider {
  $root: &;
  position: relative;
  margin-bottom: 3rem;
  background: $cWhite;

  &__inner {
    position: relative;
  }

  &__header {
    padding: 3rem;
    border-bottom: 1px solid $cAddLight;

    @include rwd('small-tablet') {
      padding: 2rem;
    }

    h2 {
      font-size: 3rem;
      line-height: 4rem;
      font-weight: 600;

      @include rwd('tablet') {
        font-size: 2.6rem;
        line-height: 3.2rem;
      }
    }
  }

  &__navigationButton {
    display: flex;
    justify-content: center;
    align-items: center;
    top: 50%;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: $cWhite;
    box-shadow: 0 3px 3px rgba($cMainDark, 0.1);
    z-index: 1;

    &.swiper-button-disabled {
      opacity: 0.6;
    }

    &::after {
      display: none;
    }

    &--prev {
      left: -20px;
    }

    &--next {
      right: -20px;
    }
  }

  &__navigationButtonIcon {
    font-size: 1.4rem;
    line-height: 1;
    color: $cAddDark;
  }

  &__slide {
    position: relative;
    display: flex;
    padding: 3rem;
    height: auto;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: $cWhite;
    border-right: 1px solid $cLightGrey;

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 3px;
      background-color: $cSec;
      border-top-left-radius: 2px;
      border-top-right-radius: 2px;
      opacity: 0;
      transition: opacity $tr;
    }

    &:hover {
      cursor: pointer;

      &::after {
        opacity: 1;
      }

      #{$root}__slideIcon {
        color: $cSec;
      }
    }
  }

  &__slideIcon {
    font-size: 4rem;
    color: $cAddDark;
    transition: color $tr;

    @include rwd('large-tablet') {
      font-size: 3rem;
    }
  }

  &__slideTitle {
    margin-top: 0.5rem;
    font-size: 1.7rem;
    line-height: 2.1rem;
    color: $cMainDark;
    text-align: center;

    @include rwd('large-laptop') {
      font-size: 1.6rem;
    }

    @include rwd('tablet') {
      font-size: 1.4rem;
    }
  }
}
</style>
